
jQuery( document ).ready(function( $ ) {

	// Remove empty headings
	//$('h1:empty').remove();

	// AppendAround jumbotron element
	$( ".jumbotron" ).appendAround();
	$( ".bio" ).appendAround();

	$('.carousel').carousel({
        interval: 5000 //changes the speed
    })

	// Change the default behavior of nav menu
	var slideDuration;
	slideDuration = 100;
	$('.nav li.dropdown').hover(function () {
	    $(this).children('.dropdown-menu').stop(true, true).delay(100).fadeIn({ duration: slideDuration, queue: false }).css('display', 'none').slideDown(slideDuration);
	}, function () {
	    $(this).children('.dropdown-menu').stop(true, true).delay(200).fadeOut({ duration: slideDuration, queue: false }).slideUp(slideDuration);
	});

	$('.nav-tabs--publications li a[data-toggle="tab"]').click(function () {
			var tabs = $(this).closest('.nav-tabs--publications');
			tabs.removeClass('open');
			tabs.find('.publication-type-select .nav-tab--selected').text($(this).children().text());
	});

	$('.nav-tabs--publications .publication-type-select').click(function () {
			$(this).parent().toggleClass('open');
	});

	// Mobile carets click to expand / collapse
	$('#menu-top-navigation-menu > li span.caret').click(function() {
		if ( $(this).parent().hasClass('open') ) {
			$(this).removeClass('open');
			$(this).parent().find(".dropdown-menu").hide('fast');
		} else {
			$("#menu-top-navigation-menu > li.open").not(this).removeClass('open');
			$(this).parent().find(".dropdown-menu").show('fast');
		}

		$(this).parent().toggleClass('open');

	});

	// Ensure footer sticks to bottom of page
	//var docHeight = $(window).height();
	//var footerHeight = $('footer').height();
	//var footerTop = $('footer').position().top + footerHeight;

	//if (footerTop < docHeight) {
    //	$('footer').css('margin-top', 10 + (docHeight - footerTop) + 'px');
   	//}

   	// WYSIWYG Widget read more functionality
   	$('.textwidget.readmore').parent().append('<a class="readmore" href="#">Read More</a>');

    $('a.readmore').click(function(e){
	    e.preventDefault();

	    if ($(this).text() == 'Read More') {
		    $(this).text('Read Less');
		    $(this).prev().addClass('open', 5000);
	    } else {
		    $(this).text('Read More');
		    $(this).prev().removeClass('open', 5000);
	    }

    })


   	/*
   	$('.widget_mit-pf-wysiwyg p').contents().each(function() {
	    if ( this.nodeType === 8 && this.nodeValue == 'more' ) {
		   var i = $(this).index();
	       $(this).parent('p').addClass('accordion').append('<a href="javascript:void(0);" data-toggle="collapse" data-target="#collapse' + i + '">Read more</a>').nextAll().css( "background-color", "red" ).wrapAll("<div id='collapse" + i + "' class='accordion-more' />");
	    }
	});*/
   	
   	// Add scroll class to nav on scroll
   	if( $( document ).scrollTop() > 0 ){
		$( '.navbar' ).addClass( 'nav-scrolled' );			
	}
	// Add opacity class to site header
	$( document ).on('scroll', function(){
		if ( $( document ).scrollTop() > 0 ){
			$( '.navbar' ).addClass( 'nav-scrolled' );			
		} else {
			$( '.navbar' ).removeClass( 'nav-scrolled' );			
		}
	});

});


// Social share popup
;(function($){

  /**
   * jQuery function to prevent default anchor event and take the href * and the title to make a share pupup
   *
   * @param  {[object]} e           [Mouse event]
   * @param  {[integer]} intWidth   [Popup width defalut 500]
   * @param  {[integer]} intHeight  [Popup height defalut 400]
   * @param  {[boolean]} blnResize  [Is popup resizeabel default true]
   */
  $.fn.customerPopup = function (e, intWidth, intHeight, blnResize) {

    // Prevent default anchor event
    e.preventDefault();

    // Set values for window
    intWidth = intWidth || '500';
    intHeight = intHeight || '400';
    strResize = (blnResize ? 'yes' : 'no');

    // Set title and open popup with focus on it
    var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
        strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize,
        objWindow = window.open(this.attr('href'), strTitle, strParam).focus();
  }

  /* ================================================== */

  $(document).ready(function ($) {
    $('.customer.share').on("click", function(e) {
      $(this).customerPopup(e);
    });
  });

}(jQuery));
